/* eslint-disable */
import {
  FormControlLabel,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Field } from 'formik';
import InfoIconOutline from '@material-ui/icons/InfoOutlined';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import ElegantSwitch from '../../../../../Shared/ElegantSwitch';

const useStyles = makeStyles((theme) => ({
  switchControl: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(2),
    transition: 'opacity 0.3s ease-in',
    opacity: 1,
    '& .MuiTypography-body1': {
      fontSize: '1rem',
      fontWeight: 400,
      marginLeft: theme.spacing(1),
    },
  },
  automationIcon: {
    height: 20,
    color: theme.palette.secondary.main,
    '&$checked': {
      color: theme.palette.secondary.main,
    },
  },
  error: {
    color: theme.palette.error.main,
    marginLeft: 14,
    marginRight: 14,
    marginBottom: 8,
    fontSize: '0.75rem',
    lineHeight: 1.66,
    letterSpacing: '0.03333em',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
  },
}));


const CheckBoxOption = ({
                          optionKey,
                          onChange,
                          backendErrors,
                          disabled,
                          setBackendErrors,
                        }) => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const classes = useStyles();

  // Check if there's an error for this field
  const hasError = !!(backendErrors['userPermissions.' + optionKey] || backendErrors?.userPermissions?.[optionKey]);
  return <>
    <div className={classes.container}>
      <Field name={'userPermissions.' + optionKey} type='checkbox'>
        {({ field, form }) => (
          <FormControlLabel
            control={
              <ElegantSwitch
                disabled={disabled}
                name={field.name}
                checked={field.value}
                error={hasError}
                onChange={(e, checked) => {
                  if (!!onChange) {
                    onChange(checked, form, field);
                  } else {
                    form.setFieldValue(field.name, checked);
                    setBackendErrors({
                      ...backendErrors,
                      ['userPermissions.' + optionKey]: null,
                    });
                  }
                }}
              />
            }
            className={classes.switchControl}
            label={titles[optionKey]}
          />
        )}
      </Field>
      <Tooltip
        placement={'right'}
        title={titles[optionKey + 'Hint']}
        style={{ zIndex: 100 }}>
        <InfoIconOutline className={classes.automationIcon} />
      </Tooltip>
    </div>
    {!!(backendErrors['userPermissions.' + optionKey] || backendErrors?.userPermissions?.[optionKey]) && (
      <Typography className={cx(classes.error)}>
        {backendErrors['userPermissions.' + optionKey] || backendErrors?.userPermissions?.[optionKey]}
      </Typography>
    )}
  </>;
};

export default CheckBoxOption;
